/* smallengine theme behaviour — vanilla JS, no dependencies */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var n = (cents / 100).toFixed(2).split('.');
    var withCommas = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withCommas;
      if (k === 'amount_with_comma_separator') return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1];
      return withCommas + '.' + n[1];
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || '[]');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return []; }
  }
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2200);
  }

  /* ---------- Side panels ---------- */
  var overlay = $('.wd-close-side');
  function openPanel(el) {
    if (!el) return;
    closePanels();
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('show');
  }
  function closePanels() {
    $$('.side-panel.open, .shop-sidebar.open').forEach(function (p) { p.classList.remove('open'); p.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('show');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-close-side]');
    if (t) { e.preventDefault(); closePanels(); }
    if (e.target.closest('[data-open-mobile-nav]')) openPanel($('#mobile-nav'));
    if (e.target.closest('[data-open-sidebar]')) {
      var sb = $('#shop-sidebar');
      if (sb) openPanel(sb); else window.location.href = root + 'collections/all';
    }
    var oc = e.target.closest('[data-open-cart]');
    if (oc && !document.body.classList.contains('template-cart')) { e.preventDefault(); refreshCart(true); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePanels(); closeSearch(); closeLightbox(); } });

  /* ---------- Search overlay + predictive search ---------- */
  var so = $('#search-overlay');
  function closeSearch() { if (so) { so.classList.remove('open'); so.setAttribute('aria-hidden', 'true'); } }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search]')) { so.classList.add('open'); so.setAttribute('aria-hidden', 'false'); setTimeout(function () { $('[data-predictive-input]', so).focus(); }, 50); }
    if (e.target.closest('[data-close-search]')) closeSearch();
  });
  var pInput = $('[data-predictive-input]'), pOut = $('[data-predictive-results]'), pTimer;
  if (pInput && pOut) {
    pInput.addEventListener('input', function () {
      clearTimeout(pTimer);
      var q = pInput.value.trim();
      if (q.length < 2) { pOut.innerHTML = ''; return; }
      pTimer = setTimeout(function () {
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            pOut.innerHTML = items.length ? items.map(function (p) {
              return '<a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') +
                '<span>' + esc(p.title) + '<span class="price">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></span></a>';
            }).join('') : '<p style="grid-column:1/-1;text-align:center">No products found.</p>';
          }).catch(function () {});
      }, 250);
    });
  }

  /* ---------- Cart ---------- */
  function updateCartCounters(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
  }
  function renderDrawer(cart) {
    var body = $('[data-cart-drawer-body]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="mini-cart-empty"><svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h8l7 34h32l6-24H22"/><circle cx="24" cy="52" r="4"/><circle cx="46" cy="52" r="4"/><path d="m32 14 10 10m0-10L32 24"/></svg><p>No products in the cart.</p><a class="btn" href="' + root + '">Return to shop</a></div>';
      return;
    }
    body.innerHTML = '<ul class="mini-cart-items">' + cart.items.map(function (it) {
      return '<li><a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(it.image) + '" alt="">' : '') + '</a><div><a class="t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<span class="q">' + it.quantity + ' &times; <span class="price">' + money(it.final_price) + '</span></span></div>' +
        '<button type="button" class="rm" data-remove-line="' + esc(it.key) + '" aria-label="Remove ' + esc(it.product_title) + '">&times;</button></li>';
    }).join('') + '</ul><div class="mini-cart-foot"><div class="subtotal"><span>Subtotal:</span><span class="price">' + money(cart.total_price) + '</span></div>' +
      '<a class="btn btn-light" href="' + window.theme.routes.cart + '">View cart</a><a class="btn" href="' + root + 'checkout">Checkout</a></div>';
  }
  function refreshCart(open) {
    return fetch(window.theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCounters(cart); renderDrawer(cart); if (open) openPanel($('#cart-drawer')); return cart; });
  }
  function addToCart(id, qty, btn) {
    if (btn) btn.disabled = true;
    return fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return refreshCart(true); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart.'); })
      .finally(function () { if (btn) btn.disabled = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-to-cart]');
    if (b) { e.preventDefault(); addToCart(b.getAttribute('data-add-to-cart'), 1, b); }
    var rm = e.target.closest('[data-remove-line]');
    if (rm) {
      e.preventDefault();
      fetch(window.theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: rm.getAttribute('data-remove-line'), quantity: 0 }) })
        .then(function (r) { return r.json(); }).then(function (cart) { updateCartCounters(cart); renderDrawer(cart); });
    }
    var q = e.target.closest('[data-qty]');
    if (q) {
      var input = q.parentNode.querySelector('input');
      var min = Number(input.min || 0);
      input.value = Math.max(min, (Number(input.value) || 0) + Number(q.getAttribute('data-qty')));
    }
  });
  $$('[data-product-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(f.querySelector('[name=id]').value, f.querySelector('[name=quantity]').value, f.querySelector('[type=submit]'));
    });
  });

  /* ---------- Wishlist & compare (browser storage, like Woodmart's guest lists) ---------- */
  var LISTS = { wishlist: 'se_wishlist', compare: 'se_compare' };
  function syncListUI() {
    Object.keys(LISTS).forEach(function (name) {
      var items = store(LISTS[name]);
      $$('[data-' + name + '-count]').forEach(function (el) { el.textContent = items.length; });
      $$('[data-' + name + ']').forEach(function (btn) {
        var on = items.indexOf(btn.getAttribute('data-' + name)) > -1;
        btn.classList.toggle('added', on);
        var label = btn.querySelector('span');
        if (label && btn.hasAttribute('data-label-added')) {
          if (!btn._orig) btn._orig = label.textContent;
          label.textContent = on ? btn.getAttribute('data-label-added') : btn._orig;
        }
      });
    });
  }
  document.addEventListener('click', function (e) {
    Object.keys(LISTS).forEach(function (name) {
      var btn = e.target.closest('[data-' + name + ']');
      if (!btn) return;
      e.preventDefault();
      var h = btn.getAttribute('data-' + name), items = store(LISTS[name]);
      if (items.indexOf(h) > -1) {
        if (btn.hasAttribute('data-label-added')) { window.location.href = root + 'pages/' + name; return; }
        items.splice(items.indexOf(h), 1); toast(name === 'wishlist' ? 'Removed from wishlist' : 'Removed from compare');
      } else {
        items.push(h); toast(name === 'wishlist' ? 'Product added to wishlist' : 'Product added to compare');
      }
      store(LISTS[name], items); syncListUI();
    });
  });
  syncListUI();

  var wlPage = $('[data-wishlist-page]');
  if (wlPage) {
    var wl = store(LISTS.wishlist), wlGrid = $('[data-wishlist-grid]', wlPage);
    if (!wl.length) $('[data-empty]', wlPage).hidden = false;
    Promise.all(wl.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) {
      wlGrid.innerHTML = cards.join('');
      if (!wlGrid.children.length) $('[data-empty]', wlPage).hidden = false;
      syncListUI();
    });
  }

  var cmpPage = $('[data-compare-page]');
  if (cmpPage) {
    var cl = store(LISTS.compare);
    var renderCompare = function () {
      cl = store(LISTS.compare);
      var wrap = $('[data-compare-table]', cmpPage);
      if (!cl.length) { wrap.innerHTML = ''; $('[data-empty]', cmpPage).hidden = false; return; }
      Promise.all(cl.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?view=compare').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (ps) {
        ps = ps.filter(Boolean);
        var keys = [];
        ps.forEach(function (p) { (p.specs || []).forEach(function (s) { if (keys.indexOf(s[0]) < 0 && ['Brand', 'MPN', 'UPC'].indexOf(s[0]) < 0) keys.push(s[0]); }); });
        var row = function (label, fn) { return '<tr><th>' + label + '</th>' + ps.map(function (p) { return '<td>' + fn(p) + '</td>'; }).join('') + '</tr>'; };
        wrap.innerHTML = '<table class="compare-table"><tbody>' +
          row('', function (p) {
            return '<a href="#" class="remove" data-compare-remove="' + esc(p.handle) + '">&times; Remove</a><a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') + '</a>' +
              '<a href="' + esc(p.url) + '" style="font-weight:600;display:block;margin-bottom:8px">' + esc(p.title) + '</a><span class="price">' + money(p.price) + '</span><br><br>' +
              (p.available ? '<button type="button" class="btn btn-small" data-add-to-cart="' + p.variant_id + '">Add To Cart</button>' : '');
          }) +
          row('Brand', function (p) { return esc(p.brand); }) +
          row('Model / MPN', function (p) { return esc(p.sku); }) +
          keys.map(function (k) {
            return row(esc(k), function (p) { var s = (p.specs || []).filter(function (x) { return x[0] === k; })[0]; return s ? esc(s[1]) : '&mdash;'; });
          }).join('') + '</tbody></table>';
      });
    };
    cmpPage.addEventListener('click', function (e) {
      var r = e.target.closest('[data-compare-remove]');
      if (!r) return;
      e.preventDefault();
      var items = store(LISTS.compare); items.splice(items.indexOf(r.getAttribute('data-compare-remove')), 1);
      store(LISTS.compare, items); syncListUI(); renderCompare();
    });
    renderCompare();
  }

  /* ---------- Grid columns toggle (3 / 4) ---------- */
  var productsGrid = $('[data-products-grid]');
  if (productsGrid) {
    var cols = (function () { try { return localStorage.getItem('se_cols') || '3'; } catch (e) { return '3'; } })();
    var applyCols = function (c) {
      productsGrid.classList.toggle('cols-4', c === '4');
      $$('.view-toggle button').forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-cols') === c); });
    };
    applyCols(cols);
    $$('.view-toggle button').forEach(function (b) {
      b.addEventListener('click', function () { var c = b.getAttribute('data-cols'); try { localStorage.setItem('se_cols', c); } catch (e) {} applyCols(c); });
    });
  }

  /* ---------- Price slider ---------- */
  $$('[data-price-form]').forEach(function (f) {
    var lo = $('[data-price-min]', f), hi = $('[data-price-max]', f), gte = $('[data-price-gte]', f), lte = $('[data-price-lte]', f);
    var fmt = function (v) { return money(Number(v) * 100).replace(/\.00$/, ''); };
    var sync = function (e) {
      if (Number(lo.value) > Number(hi.value)) { if (e && e.target === lo) lo.value = hi.value; else hi.value = lo.value; }
      $('[data-price-label-min]', f).textContent = fmt(lo.value);
      $('[data-price-label-max]', f).textContent = fmt(hi.value);
    };
    lo.addEventListener('input', sync); hi.addEventListener('input', sync);
    f.addEventListener('submit', function () {
      gte.value = lo.value; lte.value = hi.value;
      gte.disabled = Number(lo.value) <= Number(lo.min);
      lte.disabled = Number(hi.value) >= Number(hi.max);
    });
  });

  /* ---------- Product gallery lightbox ---------- */
  var lb = $('[data-lightbox]');
  function closeLightbox() { if (lb) lb.classList.remove('open'); }
  function openLightbox(src, alt) { if (!lb) return; var im = lb.querySelector('img'); im.src = src; im.alt = alt || ''; lb.classList.add('open'); }
  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-lightbox-open]');
    if (item) { e.preventDefault(); var i = item.querySelector('img'); openLightbox(item.getAttribute('href'), i && i.alt); }
    if (e.target.closest('[data-zoom]')) { var first = $('[data-lightbox-open]'); if (first) openLightbox(first.getAttribute('href'), ''); }
    if (e.target.closest('[data-lightbox-close]') || e.target === lb) closeLightbox();
  });
})();
